import { Box, Flex, Text } from "@chakra-ui/react";
import React from "react";

import "../../Styles/plant.css";
import FramesCrousel from "../../Components/Home/NewDesign/Frames/FramesCrousel";
import ByPots from "./ByPots";
const ByArtFrames = () => {
  return (
    <Box mt={0}>
      <Text color={"#3C375F"} fontSize={30} fontWeight={"bold"}>
        Product
      </Text>
      <Text color={"#7D7D7D"} fontSize={14} fontWeight={"semibold"}></Text>
      <Flex gap={10} w={"100%"}>
        <FramesCrousel />
      </Flex>
      {/* <Flex mt={2} gap={14} flexDirection={{ md: "row", base: "column" }}>
        <Box w={{ md: "50%", base: "100%" }}>
          <Image
            src={"https://images.wishfy.io/static/bg2home.png"}
            w={"100%"}
            h={{ md: 350, base: 250 }}
          />
        </Box>
        <Box w={{ md: "50%", base: "100%" }}>
          <Image
            src={"https://images.wishfy.io/static/bgg.png"}
            w={"100%"}
            h={{ md: 350, base: 250 }}
          />
        </Box>
      </Flex> */}
      {/* <Box bg={"white"} my={5}>
        <Image src={"https://images.wishfy.io/static/bg3.png"} />
      </Box> */}

      <Box>
        <ByPots />
      </Box>

      {/* <Grid
        templateColumns={{ md: "repeat(2, 1fr)", base: "repeat(1, 1fr)" }}
        gap={10}
        mt={5}
      >
        <Box>
          <Image src={"https://images.wishfy.io/static/11.jpg"} w={"95%"} />
        </Box>
        <Box>
          <Image src={"https://images.wishfy.io/static/22.jpg"} w={"95%"} />
        </Box>
        <Box>
          <Image src={"https://images.wishfy.io/static/33.jpg"} w={"95%"} />
        </Box>
        <Box>
          <Image src={"https://images.wishfy.io/static/44.jpg"} w={"95%"} />
        </Box>
      </Grid> */}
    </Box>
  );
};

export default ByArtFrames;
